import { render, staticRenderFns } from "./resourceModify.vue?vue&type=template&id=5c3631ae&scoped=true"
import script from "./resourceModify.vue?vue&type=script&lang=js"
export * from "./resourceModify.vue?vue&type=script&lang=js"
import style0 from "./resourceModify.vue?vue&type=style&index=0&id=5c3631ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3631ae",
  null
  
)

export default component.exports